// extracted by mini-css-extract-plugin
export default {"moduleHead":"index_moduleHead_9IYKq","title":"index_title_CvYFQ","subTitle":"index_subTitle_skMzA","more":"index_more_22QFB"};